module.exports = __webpack_public_path__ + "img/nt114-04-81-1.prt.5a9d8dcf.jpg";